import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { clubesService } from '../services/clubes.service'
import type { ClubeFilters } from '../types'

export const CLUBES_KEY = 'clubes'

export function useClubes(filters: ClubeFilters = {}) {
  return useQuery({
    queryKey: [CLUBES_KEY, filters],
    queryFn: () => clubesService.list(filters),
  })
}

export function useClube(id: number | null) {
  return useQuery({
    queryKey: [CLUBES_KEY, id],
    queryFn: () => clubesService.getById(id!),
    enabled: id !== null,
  })
}

export function useCreateClube() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: clubesService.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: [CLUBES_KEY] }),
  })
}

export function useUpdateClube() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) => clubesService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [CLUBES_KEY] }),
  })
}

export function useDeleteClube() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => clubesService.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [CLUBES_KEY] }),
  })
}
